module.exports = __webpack_public_path__ + "static/media/norwegian-air.f23bafd7.svg";